import { render, staticRenderFns } from "./BusinessMenuItem.vue?vue&type=template&id=fccfa4de&scoped=true&"
import script from "./BusinessMenuItem.vue?vue&type=script&lang=ts&"
export * from "./BusinessMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessMenuItem.vue?vue&type=style&index=0&id=fccfa4de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccfa4de",
  null
  
)

export default component.exports